function initBrandLogoCarousels() {
    document.querySelectorAll('.brand-logo-carousel:not([data-carousel-init])').forEach(function (carousel) {
        carousel.setAttribute('data-carousel-init', '1');

        var track = carousel.querySelector('.brand-logo-carousel__track');
        var prevBtn = carousel.querySelector('.brand-logo-carousel__arrow--prev');
        var nextBtn = carousel.querySelector('.brand-logo-carousel__arrow--next');

        if (!track || !prevBtn || !nextBtn) return;

        var originals = Array.prototype.slice.call(track.children);
        if (originals.length === 0) return;

        function cloneSet(setName) {
            var frag = document.createDocumentFragment();
            originals.forEach(function (el) {
                var clone = el.cloneNode(true);
                clone.setAttribute('aria-hidden', 'true');
                clone.setAttribute('tabindex', '-1');
                clone.setAttribute('data-clone', setName);
                frag.appendChild(clone);
            });
            return frag;
        }

        var setWidth = 0;
        var scrollEndTimer = null;

        function measureSetWidth() {
            var w = 0;
            originals.forEach(function (el) {
                w += el.getBoundingClientRect().width;
            });
            var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
            if (originals.length > 1) w += gap * originals.length;
            setWidth = w;
        }

        function getItemStep() {
            var first = originals[0];
            if (!first) return track.clientWidth * 0.8;
            var rect = first.getBoundingClientRect();
            var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
            return rect.width + gap;
        }

        function jumpTo(newSl) {
            var prev = track.style.scrollBehavior;
            track.style.scrollBehavior = 'auto';
            track.scrollLeft = newSl;
            track.style.scrollBehavior = prev;
        }

        var loopEnabled = false;

        function setupClones() {
            // Originals fit in viewport — no overflow to wrap. Skip cloning, degrade to non-looping carousel.
            if (track.scrollWidth <= track.clientWidth) {
                loopEnabled = false;
                return;
            }
            track.appendChild(cloneSet('next'));
            track.insertBefore(cloneSet('prev'), track.firstChild);
            measureSetWidth();
            jumpTo(setWidth);
            loopEnabled = true;
        }

        function checkBoundary() {
            if (!loopEnabled || setWidth === 0) return;
            var sl = track.scrollLeft;
            if (sl < setWidth) {
                jumpTo(sl + setWidth);
            } else if (sl >= setWidth * 2) {
                jumpTo(sl - setWidth);
            }
        }

        function clickStep(direction) {
            if (!loopEnabled || setWidth === 0) {
                track.scrollBy({ left: direction * (getItemStep() || track.clientWidth * 0.8), behavior: 'smooth' });
                return;
            }
            var step = getItemStep();
            var sl = track.scrollLeft;
            var targetSl = sl + direction * step;
            // Pre-jump if next step would land in or beyond clone zone — keeps wrap infinite even at scroll-clamp edges.
            if (direction > 0 && targetSl >= setWidth * 2) {
                jumpTo(sl - setWidth);
            } else if (direction < 0 && targetSl < setWidth) {
                jumpTo(sl + setWidth);
            }
            track.scrollBy({ left: direction * step, behavior: 'smooth' });
        }

        prevBtn.addEventListener('click', function () { clickStep(-1); });
        nextBtn.addEventListener('click', function () { clickStep(1); });

        track.addEventListener('scroll', function () {
            clearTimeout(scrollEndTimer);
            scrollEndTimer = setTimeout(checkBoundary, 120);
        }, { passive: true });

        var resizeTimer;
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                if (!loopEnabled) return;
                measureSetWidth();
                jumpTo(setWidth);
            }, 150);
        }, { passive: true });

        if (document.readyState === 'complete') {
            setupClones();
        } else {
            window.addEventListener('load', setupClones, { once: true });
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBrandLogoCarousels);
} else {
    initBrandLogoCarousels();
}
